import { render, staticRenderFns } from "./DeletedRemittances.vue?vue&type=template&id=3c392c74&"
import script from "./DeletedRemittances.vue?vue&type=script&lang=js&"
export * from "./DeletedRemittances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports